var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"actions",class:{ special: _vm.special}},_vm._l((_vm.buttons),function(item,index){return _c('li',{key:index},[_c('action-button',{attrs:{"text":item.text,"href":item.href,"extraClasses":item.class}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }